<template>
<div v-if="asignacion_items">
    <Box @close="close({})">
        <template #top>Asignación N° {{ asi_id }}</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-subtitle-1">Datos</div>
                    <div class="nj-gridx">
                        <LabelGroup label="Solicitante" :value="asignacion_items.emp_solicitante_nombre"></LabelGroup>
                        <LabelGroup label="Autorizador" :value="asignacion_items.emp_autorizador_nombre"></LabelGroup>
                        <LabelGroup label="Registrado por" :value="asignacion_items.usu_registrador_nombre"></LabelGroup>
                        <LabelGroup label="Fecha de asignación" :value="asignacion_items.asi_fecha_registro"></LabelGroup>
                    </div>
                    <br>
                    <div class="nj-subtitle-1">Items</div>
                    <b-table :data="asignacion_items.lista_asignacion_items_detalle">
                        <template slot-scope="props">
                            <b-table-column label="ID" header-class="is-info">{{ props.row.pal_id }}</b-table-column>
                            <b-table-column label="Producto" header-class="is-info">{{ labeProducto(props.row) }}</b-table-column>
                            <b-table-column label="Cantidad asignada" header-class="is-info">{{ props.row.aid_cantidad }}</b-table-column>
                            <b-table-column label="Cantidad devuelta" header-class="is-info">{{ props.row.did_cantidad_total }}</b-table-column>
                            <b-table-column label="Saldo" header-class="is-info">{{ props.row.aid_saldo }}</b-table-column>
                            <b-table-column label="Observaciones" header-class="is-info">{{ props.row.aid_notas }}</b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
    </Box>
</div>
</template>

<script>
import { Box, LabelGroup } from "../components"
import Toast from "../../util/toast"
import { AsignacionItemsService, LabelService, ResponseStatus } from "../../services"

export default {
    name: "VerAsignacionItems",
    props: {
        asi_id: {
            type: Number
        }
    },
    components: {
        LabelGroup,
        Box,
    },
    data() {
        return {
            asignacion_items: null
        }
    },
    methods: {
        obtener() {
            AsignacionItemsService
                .obtener({
                    asignacion_items: {
                        asi_id: this.asi_id
                    }
                })
                .then(response => {
                    this.asignacion_items = response.data
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        labeProducto(item) {
            return LabelService.productoAlmacenSerie(item)
        },
        close({
            view = ""
        }) {
            this.$emit("close", {
                view
            })
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>